exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.textHeader {\n  height: 17px;\n  width: 37px;\n  color: #FFFFFF;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 10px;\n  line-height: 17px;\n}\ntbody {\n  background-color: #ffffff;\n}\n.table thead th {\n  height: 37px;\n  background-color: #231F20;\n}\ntable.b-table tfoot>tr>.sorting:after,\ntable.b-table tfoot>tr>.sorting:before,\ntable.b-table thead>tr>.sorting:after,\ntable.b-table thead>tr>.sorting:before {\n  background-color: #ffffff;\n}\ntable.b-table>tfoot>tr>.sorting:after,\ntable.b-table>thead>tr>.sorting:after {\n  background-color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-287dfa9c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Drafts.vue
// module id = 1868
// module chunks = 1